import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n';
import { useSEO } from '../hooks/useSEO';
import styles from './MarketStandbyPage.module.css';

export function MarketStandbyPage() {
  const { t } = useLanguage();

  useSEO({
    title: t.consensus.title,
    description: t.consensus.subtitle,
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Link to="/" className={styles.backLink}>
            &larr; {t.consensus.backToDashboard}
          </Link>
          <h1 className={styles.title}>{t.consensus.title}</h1>
          <p className={styles.subtitle}>{t.consensus.subtitle}</p>
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.section}>
          {/* What is Smart Scheduling */}
          <div className={styles.card}>
            <h2 className={styles.cardTitle}>{t.consensus.whatIsConsensus}</h2>
            <p className={styles.cardText}>{t.consensus.whatIsConsensusDesc}</p>
          </div>

          {/* Benefits */}
          <div className={styles.card}>
            <h2 className={styles.cardTitle}>{t.consensus.whyBetter}</h2>
            <p className={styles.cardText}>{t.consensus.whyBetterIntro}</p>
            <ul className={styles.benefitList}>
              {t.consensus.whyBetterPoints.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          </div>

          {/* How it Works */}
          <div className={styles.card}>
            <h2 className={styles.cardTitle}>{t.consensus.howItWorks}</h2>
            <p className={styles.cardText}>{t.consensus.howItWorksDesc}</p>
            <ol className={styles.stepList}>
              {t.consensus.howItWorksSteps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </div>

          {/* Optimization Criteria (no formula, just factors) */}
          <div className={styles.card}>
            <h2 className={styles.cardTitle}>{t.consensus.scoringFormula}</h2>
            <p className={styles.cardText}>{t.consensus.scoringFormulaDesc}</p>
            <ul className={styles.benefitList}>
              {t.consensus.scoringFactors.map((factor, index) => (
                <li key={index}>{factor}</li>
              ))}
            </ul>
          </div>

          {/* How to Improve */}
          <div className={styles.card}>
            <h2 className={styles.cardTitle}>{t.consensus.moreTime}</h2>
            <p className={styles.cardText}>{t.consensus.moreTimeIntro}</p>
            <ul className={styles.tipList}>
              {t.consensus.moreTimeTips.map((tip, index) => (
                <li key={index}>{tip}</li>
              ))}
            </ul>
          </div>

          {/* Upgrade Tier CTA */}
          <div className={styles.ctaCard}>
            <h2 className={styles.cardTitle}>{t.consensus.upgradeTier}</h2>
            <p className={styles.cardText}>{t.consensus.upgradeTierDesc}</p>
            <Link to="/payment-plans" className={styles.ctaButton}>
              {t.consensus.viewPlans}
            </Link>
          </div>

          {/* Status Explanation */}
          <div className={styles.statusCard}>
            <h2 className={styles.cardTitle}>{t.consensus.statusExplanation}</h2>
            <p className={styles.cardText}>{t.consensus.statusExplanationDesc}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
